<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      resizable
      border
      size="small"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:currencyAmount="{ row }">
        <span>{{ row.currencyAmount }} {{ row.currencyUnit }}</span>
      </template>
      <template v-slot:userReimbursementStatus="{ row }">
        <el-tag size="mini" :type="'success'">
          {{ '已审核' }}
        </el-tag>
      </template>

      <template v-slot:forwardGeneralManager="{ row }">
        <el-tag
          v-if="['0', '1'].includes(row.forwardGeneralManager)"
          size="mini"
          :type="row.forwardGeneralManager === '0' ? 'primary' : 'warning'"
        >
          {{ row.forwardGeneralManagerText }}
        </el-tag>
      </template>
      <template v-slot:businessConsumption="{ row }">
        <el-tag
          v-if="['0', '1'].includes(row.businessConsumption)"
          size="mini"
          :type="row.businessConsumption === '0' ? 'primary' : 'warning'"
        >
          {{ row.businessConsumptionText }}
        </el-tag>
      </template>
      <template v-slot:otherSet="{ row }">
        <el-tag
          v-if="['0', '1'].includes(row.otherSet)"
          size="mini"
          :type="row.otherSet === '0' ? 'primary' : 'warning'"
        >
          {{ row.otherSetText }}
        </el-tag>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import { format } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      visible: false,
      finPaymentNoInvoice: '',
      format: (number) => format(number),
      tableColumns: tableColumns(this),
    }
  },
  methods: {},
}
</script>
